import { useState } from 'react';
import { DefaultProductFilters } from '@/components/search/instantSearch/DefaultProductFilters';
import { Button } from '@fagmobler/ui';

import { CurrentRefinements } from '@/components/search/instantSearch/CurrentRefinements';
import { ClearRefinements } from '@/components/search/instantSearch/ClearRefinements';
import SortingButtonWithPopover from '@/components/search/SortingButtonWithPopover';
import { AdjustmentsVerticalIcon } from '@heroicons/react/20/solid';
import { excludedRefinementAttributes } from '../Search';
import { useStats } from 'react-instantsearch';
import { SearchProps } from '@/lib/algolia/createCategorySearchProps';

export const ProductCategoryListHeader = ({
  hideFacets,
}: {
  hideFacets?: SearchProps['hideFacets'];
}) => {
  const { nbHits } = useStats();
  const [showFilters, setShowFilters] = useState(false);

  return (
    <div>
      <div className="flex items-stretch flex-col sm:flex-row sm:space-x-2 mb-3">
        <div className="flex flex-grow items-center gap-2">
          {nbHits} produkter
          <ClearRefinements excludedAttributes={excludedRefinementAttributes} />
        </div>
        <div className="pt-3 sm:pt-0 flex space-x-2">
          <SortingButtonWithPopover />

          <Button
            className="whitespace-nowrap block pr-3 w-full justify-center"
            type="button"
            onClick={() => setShowFilters(true)}
          >
            <AdjustmentsVerticalIcon className="h-4 w-4 mr-2" />
            Vis filter{' '}
          </Button>
        </div>
      </div>

      <CurrentRefinements excludedAttributes={excludedRefinementAttributes} />

      <DefaultProductFilters
        isOpen={showFilters}
        onClose={() => setShowFilters(false)}
        hideFacets={hideFacets}
      />
    </div>
  );
};

export default ProductCategoryListHeader;
